import { logError } from 'utils/helpers';

import { IterableProduct } from '../types';

export const snakeToTitle = (str: string) =>
  str.charAt(0).toUpperCase() +
  str
    .slice(1)
    .replace(/([-_][a-z])/g, (group) =>
      group.toUpperCase().replace('-', ' ').replace('_', ' '),
    );

export const trackIterable = (
  eventType: string,
  eventId: string | number,
  product: IterableProduct,
) => {
  try {
    if (
      typeof window !== 'undefined' &&
      //hacky temporary solution until we fix Iterable events locally
      window.location.host !== 'localhost:8080'
    ) {
      window.dataLayer.push({
        event: eventType,
        eventId: eventId,
        product,
      });
    }
  } catch (err) {
    logError((err as Error).message, {
      method: 'trackIterable',
    });
  }
};
